import React from 'react';
import '../../src/styles/App.css';

const Navbar = ({ theme, toggleTheme }) => {
  const navItems = [
    'Home',
    'About',
    'Skills',
    'Services',
    'Projects',
    'Experience',
    'Contact'
  ];

  return (
    <nav className="navbar navbar-expand-lg py-3">
      <div className="container container-lg">
        
        {/* Brand Name */}
        <a className="brand navbar-brand" href="#home">
          Kumail Abbas
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav ms-auto align-items-center">
            {navItems.map(item => (
              <li key={item} className="nav-item">
                <a className="nav-link" href={`#${item.toLowerCase()}`}>
                  {item}
                </a>
              </li>
            ))}

            {/* Theme Toggle */}
            <li className="nav-item ps-3">
              <button
                onClick={toggleTheme}
                className="btn btn-sm btn-ghost"
                aria-label="Toggle Theme"
              >
                {theme === 'dark' ? '☀️' : '🌙'}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
